module.exports = __webpack_public_path__ + "img/sld_star_delta_transformer_h_r1_l1-16_dark.8209fdae.svg";